module.exports = __webpack_public_path__ + "img/sentiment.3b8bd9d9.png";